export enum PerfilEnum {
  ADMIN,
  PRESTADOR,
  INSTITUCIONAL,
  MARKETING,
}



// WEBPACK FOOTER //
// ./src/app/components/base/enum/perfil.ts